<hs-no-loaded-account [content]="extFileViewerContent"> </hs-no-loaded-account>

<ng-template #extFileViewerContent>
  <div class="actions-grid-container" #externalDataGrid>
    <hs-external-file-viewer-grid
      [filterState]="mainGridFilter$ | async"
      [dateRangeFilter]="dateRangeFilter"
      [account]="selectedAccount"
      [rawDataFilterData]="selectedRawDataFilter"
      [updatedRawDataSelectedList]="selectedRawDataList"
      (rawDataSelectedList$)="setSelectedRawData($event)"
      (selectDateRangeFilter)="setDateRangeFilter($event)"
    >
    </hs-external-file-viewer-grid>
  </div>
  <hs-resize-handle
    [elem1]="externalDataGrid"
    [elem2]="subPanels"
    [initialResizeHandleState]="state?.resizeHandleState"
    (resizeFinished)="onResizeFinished($event)"
  ></hs-resize-handle>

  <div id="details-sub-panels" #subPanels>
    <ul
      ngbNav
      #nav="ngbNav"
      [(activeId)]="activeTab"
      class="nav-tabs"
      (navChange)="resetSelection()"
    >
      <li
        [destroyOnHide]="false"
        [ngbNavItem]="i + 1"
        *ngFor="let item of selectedRawDataList; index as i"
        [contextMenu]="basicMenu"
        [contextMenuSubject]="item"
      >
        <a ngbNavLink data-toggle="tooltip" title="{{ item.fileDescription }}">
          {{ item.accountId }} : {{ item.reconDate }} : {{ item.fileType }}
          <button
            nf-icon-button
            icon="close"
            class="btn-bare"
            (click)="close($event, item)"
          ></button>
        </a>
        <ng-template ngbNavContent>
          <hs-external-file-viewer-details
            [savedViews]="fileGridFilters$ | async"
            [externalRawData]="item"
          ></hs-external-file-viewer-details>
        </ng-template>
      </li>
    </ul>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>

  <context-menu class="dropdown ngx-contextmenu">
    <ng-template contextMenuItem (execute)="closeAll()">Close all</ng-template>
    <ng-template contextMenuItem [divider]="true"></ng-template>
    <ng-template contextMenuItem (execute)="closeAll($event.item)"
      >Close all other</ng-template
    >
  </context-menu>
</ng-template>
